import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const DEV_CONFIG = {
  apiKey: "AIzaSyCI0lIP1F51ObsiTo8L76-t7ZDj--GywpY",
  authDomain: "groomin-test.firebaseapp.com",
  databaseURL: "https://groomin-test-default-rtdb.firebaseio.com",
  projectId: "groomin-test",
  storageBucket: "groomin-test.appspot.com",
  messagingSenderId: "872591729206",
  appId: "1:872591729206:web:74772c0145f69165e72e97"
};

const PROD_CONFIG = {
  apiKey: "AIzaSyC1dwEWsERDG6uD7Kbfu-3UA-ECJh5-QHw",
  authDomain: "groomcard-ee632.firebaseapp.com",
  databaseURL: "https://groomcard-ee632.firebaseio.com",
  projectId: "groomcard-ee632",
  storageBucket: "groomcard-ee632.appspot.com",
  messagingSenderId: "127963044883",
  appId: "1:127963044883:web:f45c70cd71596ae0f5b3e6"
};

const config = process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEV_CONFIG;

export const db = firebase
  .initializeApp(config)
  .database()
window.db = db
window.firebase = firebase
export const googleAuthProvider = new firebase
  .auth.GoogleAuthProvider()
  .setCustomParameters({
    prompt: 'select_account'
  })

// db.settings({ timestampsInSnapshots: true })
